// extracted by mini-css-extract-plugin
export default {"container":"InfiniteScroll_container__XEP6L","loader":"InfiniteScroll_loader__EecHy"};